// Base URLs
export const API_BASE = 'https://ccs.whiteneuron.com';
// export const API_BASE = 'http://localhost:8000';
// export const API_BASE = 'http://192.168.50.79:8000';
export const API_BASE_LOINC = 'https://loinc.whiteneuron.com';

// Embedded URLs
export const API_PANELS_AND_FORMS = 'https://loinc.whiteneuron.com/tools/forms';
export const SNOMEDCT_BROWSER_URL = 'https://snomedct.whiteneuron.com/tools/browser/';
export const DMKT_BROWSER_URL = 'https://dmkt.kcb.vn';

// ICD-10 Base path (trailing / for concatenation)
const ICD10_BASE = `${API_BASE}/api/ICD10/`;
export const API_ICD10_ROOT = `${ICD10_BASE}root`;
export const API_ICD10_DATA = `${ICD10_BASE}data/`;
export const API_ICD10_CHILD = `${ICD10_BASE}childs/`;

// ICD-10 TT06 Base path (trailing / for concatenation)
const ICD10_TT06_BASE = `${API_BASE}/api/ICD10_TT06/`;
export const API_ICD10_TT06_ROOT = `${ICD10_TT06_BASE}root`;
export const API_ICD10_TT06_DATA = `${ICD10_TT06_BASE}data/`;
export const API_ICD10_TT06_CHILD = `${ICD10_TT06_BASE}childs/`;

// ICD-9 Base path (trailing / for concatenation)
const ICD9_BASE = `${API_BASE}/api/ICD9/`;
export const API_ICD9_ROOT = `${ICD9_BASE}root`;
export const API_ICD9_DATA = `${ICD9_BASE}data/`;
export const API_ICD9_CHILD = `${ICD9_BASE}childs/`;

// YHCT Base path (trailing / for concatenation) - version-based API
const YHCT_BASE = `${API_BASE}/api/YHCT/`;
export const API_YHCT_ROOT = `${YHCT_BASE}root`;
export const API_YHCT_DATA = `${YHCT_BASE}data/`;
export const API_YHCT_CHILD = `${YHCT_BASE}childs/`;

// ICF Base path (trailing / for concatenation) - same pattern as ICD-10
const ICF_BASE = `${API_BASE}/api/ICF/`;
export const API_ICF = ICF_BASE;
export const API_ICF_ROOT = `${ICF_BASE}root`;
export const API_ICF_DATA = `${ICF_BASE}data/`;
export const API_ICF_CHILD = `${ICF_BASE}childs/`;
export const API_ICF_SEARCH = `${ICF_BASE}search/`;
export const API_ICF_TREE = `${ICF_BASE}tree/`;

// Feedback Endpoints
export const API_FEEDBACK_BASE = `${API_BASE}/api/feedback/`;
export const API_FEEDBACK_APP = (appname: string) => `${API_BASE}/api/${appname}/feedback/`;

// Document Endpoints
export const API_DOC_LIST = (category: string) => `${API_BASE}/api/DOC/list/${category}`;
export const API_DOC_DATA = (id: number) => `${API_BASE}/api/DOC/data/${id}`;

// Smart Search Endpoints
export const API_SMART_SEARCH_RECOMMEND = `${API_BASE}/api/ICDSmartSearch/recommend`;
export const API_SMART_SEARCH_APPS = `${API_BASE}/api/ICDSmartSearch/apps`;
export const API_SMART_SEARCH = `${API_BASE}/api/ICDSmartSearch/search`;
export const API_SMART_SEARCH_EVALUATE = `${API_BASE}/api/ICDSmartSearch/evaluate/`;
export const API_SMART_SEARCH_GET_EVALUATES = `${API_BASE}/api/ICDSmartSearch/get_evaluates/`;

// Dashboard Endpoints (MCCD)
const DASHBOARD_BASE = `${API_BASE}/api/MCCD/`;
export const API_DASHBOARD = DASHBOARD_BASE;
export const API_DASHBOARD_LINEAR = `${DASHBOARD_BASE}linearechart`;
export const API_DASHBOARD_TABLE = `${DASHBOARD_BASE}tablechart`;
export const API_DASHBOARD_MAP = `${DASHBOARD_BASE}mapchart`;
export const API_DASHBOARD_DISEASE = `${DASHBOARD_BASE}get-list-disease`;
export const API_DASHBOARD_HOSPITAL = `${DASHBOARD_BASE}get-list-hospital`;
export const API_DASHBOARD_TEXTBOX = `${DASHBOARD_BASE}textbox`;
export const API_DASHBOARD_SYNC = `${DASHBOARD_BASE}syncchart`;
export const API_DASHBOARD_NEGA = `${DASHBOARD_BASE}negachart`;
export const API_DASHBOARD_VIETNAM = `${DASHBOARD_BASE}vietnamchart`;
export const API_DASHBOARD_BUBBLE = `${DASHBOARD_BASE}bubblechart`;
export const API_DASHBOARD_MATRIX = `${DASHBOARD_BASE}chart-matrix`;
export const API_DASHBOARD_UCOD_TEXTBOX = `${DASHBOARD_BASE}ucod-textbox`;
export const API_DASHBOARD_UCOD_BOARD = `${DASHBOARD_BASE}ucod-board`;
export const API_DASHBOARD_UCOD_LINE = `${DASHBOARD_BASE}ucod-line`;
export const API_DASHBOARD_UCOD_HEATMAP = `${DASHBOARD_BASE}ucod-confusion-matrix`;

export const API_SYS_UNIQUE_CLIENTS = `${API_BASE}/unique_clients/`;
export const API_SYS_UNIQUE_USAGES = `${API_BASE}/unique_usage/`;
export const API_SYS_TREEMAP = `${API_BASE}/treemap_data/`;

// UCOD Tool Endpoints
export const API_TOOL = `${API_BASE}/api/ucod/diagnose`;

// LOINC Base path (trailing / for concatenation)
const LOINC_BASE = `${API_BASE_LOINC}/api/loinc/`;
export const API_LOINC = LOINC_BASE;
export const API_LOINC_TABLE = `${LOINC_BASE}loinc-table/`;
export const API_LOINC_MAP_TO = `${LOINC_BASE}map-to/`;
export const API_LOINC_PANELS_FORMS = `${LOINC_BASE}panels-and-forms/`;
export const API_LOINC_PART = `${LOINC_BASE}part/`;
export const API_LOINC_PART_LINK = `${LOINC_BASE}loinc-part-link/`;
export const API_LOINC_ANSWER_LIST = `${LOINC_BASE}answer-list/`;
export const API_LOINC_ANSWER = `${LOINC_BASE}answer/`;
export const API_LOINC_ANSWER_LIST_LINK = `${LOINC_BASE}loinc-answer-list-link/`;
